import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getPrivacyPolicy = createAsyncThunk("admin/privacyPolicy", async (type = "course", { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/privacy-policy?type=${type}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const editPrivacyPolicy = createAsyncThunk("admin/editPrivacyPolicy", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/privacy-policy/add/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getTermsCondition = createAsyncThunk("admin/termsCondition", async (type = "course", { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/terms-condition?type=${type}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const editTermsCondition = createAsyncThunk("admin/editTermsCondition", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/terms-condition/add/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getRefundPolicy = createAsyncThunk("admin/refundPolicy/get", async (type = "course", { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/refund-policy?type=${type}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const editRefundPolicy = createAsyncThunk("admin/refundPolicy/edit", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/refund-policy/add/edit`, payload, { headers: authHeader() });
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getLegality = createAsyncThunk("admin/legality", async (type = "course", { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/illegality?type=${type}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const editLegality = createAsyncThunk("admin/legality", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/illegality/add/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getAboutUs = createAsyncThunk("admin/about-us", async (type = "course", { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/about-us?type=${type}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const editAboutUs = createAsyncThunk("admin/about-us", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/about-us/add/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {};

const informationSlice = createSlice({
  name: "informationSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPrivacyPolicy.fulfilled, (state, action) => {
      state.privacyPolicyData = action.payload.data;
    });
    builder.addCase(getTermsCondition.fulfilled, (state, action) => {
      state.termsConditionData = action.payload.data;
    });
    builder.addCase(getRefundPolicy.fulfilled, (state, action) => {
      state.refundPolicyData = action.payload.data;
    });
    builder.addCase(editRefundPolicy.fulfilled, (state, action) => {
      state.refundPolicyData = action.payload.data;
    });
    builder.addCase(getLegality.fulfilled, (state, action) => {
      state.legality = action.payload.data;
    });
    builder.addCase(getAboutUs.fulfilled, (state, action) => {
      state.aboutUs = action.payload.data;
    });
  },
});
export default informationSlice.reducer;
